/**
 * 科技创新申报
 */
export default {
  BASE_URL: 'psm/technol/project',
  api: [
    {
      name: 'pageStatus',
      desc: '获取页签',
      method: 'GET',
      path: '/admin/pageStatus'
    },
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/admin/list'
    },
    {
      name: 'audit',
      desc: '审核',
      method: 'PUT',
      path: '/admin/audit'
    },
    {
      name: 'review',
      desc: '评选',
      method: 'POST',
      path: '/admin/review'
    },
    {
      name: 'detail',
      desc: '申报详情',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'export',
      desc: 'excel导出',
      method: 'POST',
      path: '/admin/export'
    },
    {
      name: 'batchUpdate',
      desc: '分组信息批量更新',
      method: 'POST',
      path: '/admin/group/batchUpdate'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/psm/innovate/index.js